// Generated by CoffeeScript 2.7.0
var BaseField, FIELD_GROUPS;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

FIELD_GROUPS = [
  {
    label: '提交日期',
    type: 'ProposeTime'
  },
  {
    label: '固定字符',
    type: 'ConstText'
  },
  {
    label: '表单内字段',
    type: 'FormFields'
  },
  {
    label: '发起人姓名',
    type: 'Proposer'
  }
];

export default BaseField = Vue.extend({
  components: {
    Dropdown: DropdownSelect
  },
  template: `<div
  :class='statusClass'
  class="field-view serial-number-field-view"
  @click='enableEdit'
>
  <div class="field-drag-area dragable">
    <i class="slp-move text-large"></i>
  </div>
  <div class="justify-box">
    <div class="field-header content">
      <div class="justify-box status-container" v-if='editing'>
        <slot name='typeOptionBar'>
          <Dropdown :optionGroups='fieldGroups'
                    :initValue='currentGroup'
                    :optionGroupsFixed='true'
                    @change='optionChanged'>
            <template slot='value-template' slot-scope='{ option }'>
              <span>{{ option.label }}</span>
            </template>
            <template slot='option-template' slot-scope='{ option }'>
              <span>{{ option.label }}</span>
            </template>
          </Dropdown>
        </slot>
        <slot name='optionbar'></slot>
      </div>
      <div class="justify-box title-container">
        <div class="light-gray-text mt-2" v-if='editing'>
          <slot name='description'></slot>
        </div>
        <div class="content" v-if="!editing">
          <div><slot name="title">{{ field.title || defaultFieldTitle }}</slot></div>
          <div class="gray-text mt-2"><slot name='content'></slot></div>
        </div>
      </div>
    </div>
  </div>
  <div class="field-delete-button icon-btn">
    <i class="slp-trash" @click="removeField"></i>
  </div>
</div>`,
  props: {
    field: {
      type: Skylark.App.Model.Field.Base,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusClass: function() {
      return {
        'field-editing': this.editing
      };
    },
    currentGroup: function() {
      var field_type;
      field_type = this.field.type;
      if (field_type === 'Field::RadioButton' || field_type === 'Field::DateTime') {
        field_type = 'FormFields';
      }
      return _.find(this.fieldGroups[0].options, function(option) {
        return option.type === field_type;
      });
    },
    defaultFieldTitle: function() {
      var ref;
      return (ref = this.currentGroup) != null ? ref.label : void 0;
    },
    fieldGroups: function() {
      var form_fields;
      ({form_fields} = this.field.settings);
      return [
        {
          options: _.reduce(FIELD_GROUPS,
        function(acc,
        field) {
            if (field.type === 'FormFields' && (!form_fields.length)) {
              return acc;
            }
            acc.push(field);
            return acc;
          },
        [])
        }
      ];
    }
  },
  methods: {
    enableEdit: function(event) {
      if (this.$el.getAttribute('moved')) {
        return;
      }
      if (this.editing) {
        return true;
      }
      this.$parent.editing = true;
      if (this.$parent.hasOwnProperty('childOnEditing')) {
        return this.$parent.childOnEditing = false;
      }
    },
    optionChanged: function(option, group) {
      return this.$parent.changeType(option);
    },
    focusTitle: function() {},
    removeField: function() {
      return this.$parent.removeField();
    }
  }
});
